import React from 'react'
import { YearMonthPickerContext } from './year-month-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type YearMonthPickerNextProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const YearMonthPickerNext = React.forwardRef<HTMLDivElement, YearMonthPickerNextProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(YearMonthPickerContext)
    if (!context) {
      throw new Error('Cannot find year month picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToNextYear)
      })
    }
  }
) as WithForwardRefType

YearMonthPickerNext.displayName = 'YearMonthPickerNext'

interface WithForwardRefType extends React.FC<YearMonthPickerNextProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(
    props: YearMonthPickerNextProps<T>
  ): ReturnType<React.FC<YearMonthPickerNextProps<T>>>
}
